import { ProductType } from '../../common/models/product-type.model';
import {
  SET_PRODUCT_TYPES,
  SET_PRODUCT_TYPES_LOADING,
  SET_PRODUCT_TYPES_ERROR,
  SET_ACTIVE_TYPE,
  ADD_PRODUCT_TYPE,
  UPDATE_PRODUCT_TYPE,
  DELETE_PRODUCT_TYPE,
} from './productTypesActionTypes';

export interface ProductTypesState {
  types: ProductType[];
  activeType: ProductType | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProductTypesState = {
  types: [],
  activeType: null,
  loading: false,
  error: null,
};

interface ProductTypesAction {
  type: string;
  payload?: any;
}

const productTypesReducer = (
  state = initialState,
  action: ProductTypesAction
): ProductTypesState => {
  switch (action.type) {
    case SET_PRODUCT_TYPES:
      return {
        ...state,
        types: action.payload,
        loading: false,
        error: null,
      };

    case SET_PRODUCT_TYPES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case SET_ACTIVE_TYPE:
      return {
        ...state,
        activeType: action.payload,
      };

    case ADD_PRODUCT_TYPE:
      return {
        ...state,
        types: [...state.types, action.payload],
      };

    case UPDATE_PRODUCT_TYPE:
      return {
        ...state,
        types: state.types.map(t =>
          t._id === action.payload._id ? action.payload : t
        ),
        activeType:
          state.activeType?._id === action.payload._id
            ? action.payload
            : state.activeType,
      };

    case DELETE_PRODUCT_TYPE:
      return {
        ...state,
        types: state.types.filter(t => t._id !== action.payload),
        activeType:
          state.activeType?._id === action.payload ? null : state.activeType,
      };

    case 'RESET':
      return { ...initialState };

    default:
      return state;
  }
};

export default productTypesReducer;
